export default "__VITE_ASSET__DJOAh_la__"